import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    checkbox1,
    fullName1,
    taxId1,
    identity,
    identity2,
    national,
    address,
    district,
    province,
    taxAgencyName,
    taxAgencyId,
    makeIn,
    dateMakeIn,
    dateAccepted,
    fullName2,
    taxId2,
    national2,
    address2,
    district2,
    province2,
    phone,
    fax,
    email,
    checkbox2,
    checkbox3,
    checkbox4,
    certificateProperty,
    certificatePropertyByWho,
    certificatePropertyDate,
    organizationInfo,
    organizationName,
    taxId3,
    district3,
    province3,
    address3,
    phone2,
    fax2,
    email2,
    amount1,
    amount2,

    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [organizationName.name]: "",
  [organizationInfo.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [checkbox3.name]: false,
  [checkbox4.name]: false,
  [fullName1.name]: "",
  [fullName2.name]: "",
  [identity.name]: "",
  [identity2.name]: "",
  [certificateProperty.name]: "",
  [certificatePropertyByWho.name]: "",
  [certificatePropertyDate.name]: "",
  [national.name]: "",
  [makeIn.name]: "",
  [dateMakeIn.name]: "",
  [dateAccepted.name]: "",
  [national2.name]: "",
  [amount1.name]: 0,
  [amount2.name]: 0,
  [address.name]: "",
  [address2.name]: "",
  [address3.name]: "",
  [email.name]: "",
  [phone.name]: "",
  [fax.name]: "",
  [email2.name]: "",
  [phone2.name]: "",
  [fax2.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxId2.name]: "",
  [taxId3.name]: "",
  [district.name]: "",
  [district2.name]: "",
  [district3.name]: "",
  [province.name]: "",
  [province2.name]: "",
  [province3.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
